import React from 'react';
import './LegalPage.css';

const RefundPolicy = () => {
  return (
    <section className="legal-page">
      <div className="container">
        <div className="legal-header">
          <span className="section-tag refund-tag">💰 Legal</span>
          <h1>Refund Policy</h1>
          <p className="legal-updated">Last updated: January 2024</p>
        </div>

        <div className="legal-content">
          <div className="legal-section">
            <h2>1. Overview</h2>
            <p>
              At Slink, we strive to provide a seamless payment experience. This Refund Policy outlines 
              the conditions under which refunds are issued for payments made within the app.
            </p>
            <p>
              For refund-related queries, contact: <a href="mailto:slink@astergo.in" className="legal-link">slink@astergo.in</a>
            </p>
          </div>

          <div className="legal-section highlight-box">
            <h2>2. Failed Payment Refunds</h2>
            <p><strong>If a payment fails due to any reason and money is deducted from your account:</strong></p>
            <ul>
              <li>The deducted amount will be automatically refunded within <strong>2 business days</strong></li>
              <li>Refund will be credited back to the original payment method (bank account/UPI)</li>
              <li>You will receive a notification once the refund is processed</li>
              <li>If the refund is not received within 2 business days, contact us at <a href="mailto:slink@astergo.in" className="legal-link">slink@astergo.in</a> with your transaction ID</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>3. Wallet Recharge Refunds</h2>
            <p>Refunds for wallet recharges are applicable in the following cases:</p>
            <ul>
              <li><strong>Payment deducted but wallet not credited:</strong> Full refund within 2 business days</li>
              <li><strong>Duplicate payment:</strong> The duplicate amount will be refunded within 2 business days</li>
              <li><strong>Overcharged amount:</strong> The excess amount will be refunded within 2 business days</li>
            </ul>
          </div>

          {/* <div className="legal-section">
            <h2>4. Non-Refundable Scenarios</h2>
            <p>Refunds will NOT be issued in the following cases:</p>
            <ul>
              <li>Wallet balance already used for video calls</li>
              <li>Completed video call charges — once a call is connected and minutes are consumed, the charges are non-refundable</li>
              <li>Account blocked due to policy violations — no refund of remaining wallet balance</li>
              <li>Voluntary spending on the platform (gifts, tips, etc.)</li>
              <li>Partial call duration — charges for the actual connected time are non-refundable</li>
            </ul>
          </div> */}

          <div className="legal-section">
            <h2>5. Call Disconnection Issues</h2>
            <p>If a video call disconnects due to technical issues from our end:</p>
            <ul>
              <li>If the call drops within the first 10 seconds, no charges will be applied</li>
              <li>If our servers cause the disconnection, the charge for that incomplete minute will be refunded to your wallet</li>
              <li>Disconnections due to user's internet issues are not eligible for refund</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>6. How to Request a Refund</h2>
            <p>To request a refund, send an email to <a href="mailto:slink@astergo.in" className="legal-link">slink@astergo.in</a> with:</p>
            <ul>
              <li>Your registered phone number or user ID</li>
              <li>Transaction ID / payment reference number</li>
              <li>Date and time of the transaction</li>
              <li>Amount to be refunded</li>
              <li>Screenshot of the payment deduction (if available)</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>7. Refund Processing Time</h2>
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Refund Type</th>
                  <th>Processing Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Failed payment (auto-refund)</td>
                  <td>1-2 business days</td>
                </tr>
                <tr>
                  <td>Duplicate payment</td>
                  <td>2-3 business days</td>
                </tr>
                <tr>
                  <td>Manual refund request</td>
                  <td>3-5 business days</td>
                </tr>
                <tr>
                  <td>Bank processing (after our refund)</td>
                  <td>5-7 business days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="legal-section">
            <h2>8. Withdrawal of Earnings</h2>
            <p>
              Earnings from video calls can be withdrawn to your registered bank account/UPI. 
              Withdrawal requests are processed within 24-48 hours. Once processed, bank transfer 
              time depends on your bank (typically 1-3 business days).
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Contact Us</h2>
            <p>For any refund-related questions:</p>
            <ul>
              <li>Email: <a href="mailto:slink@astergo.in" className="legal-link">slink@astergo.in</a></li>
              <li>Address: Kolkata, West Bengal, India</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RefundPolicy;
